function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Picture, Source, Img } from "@xo-union/tk-component-picture";
import { Skeleton, Bone } from "@xo-union/tk-ui-skeleton";
import styles from "./styles.css";
import { isMobile } from "../../utils/platform.js";
export default function LazyloadImage(_ref) {
  var _ref$containerClassNa = _ref.containerClassName,
    containerClassName = _ref$containerClassNa === void 0 ? "" : _ref$containerClassNa,
    _ref$imageClassName = _ref.imageClassName,
    imageClassName = _ref$imageClassName === void 0 ? "" : _ref$imageClassName,
    _ref$image = _ref.image,
    image = _ref$image === void 0 ? "" : _ref$image,
    alt = _ref.alt,
    ariaHidden = _ref.ariaHidden,
    desktopWidth = _ref.desktopWidth,
    desktopHeight = _ref.desktopHeight,
    mobileWidth = _ref.mobileWidth,
    mobileHeight = _ref.mobileHeight,
    smartCrop = _ref.smartCrop,
    _ref$lazy = _ref.lazy,
    lazy = _ref$lazy === void 0 ? true : _ref$lazy,
    _ref$showLoader = _ref.showLoader,
    showLoader = _ref$showLoader === void 0 ? true : _ref$showLoader,
    _ref$pictureProps = _ref.pictureProps,
    pictureProps = _ref$pictureProps === void 0 ? {} : _ref$pictureProps;
  var imgContainer = useRef(null);
  var _useState = useState(showLoader),
    _useState2 = _slicedToArray(_useState, 2),
    loader = _useState2[0],
    setLoader = _useState2[1];
  useEffect(function () {
    var _imgContainer$current;
    var img = (_imgContainer$current = imgContainer.current) === null || _imgContainer$current === void 0 ? void 0 : _imgContainer$current.querySelector("img");
    if (img) {
      var handleLoad = function handleLoad() {
        if (img.complete) {
          setLoader(false);
        }
      };
      img.addEventListener("load", handleLoad);
      return function () {
        return img.removeEventListener("load", handleLoad);
      };
    }
  }, []);
  var elementProps = {};
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles["lazyload-image-container"], " ").concat(containerClassName),
    "aria-hidden": ariaHidden,
    ref: imgContainer
  }, /*#__PURE__*/React.createElement(Skeleton, {
    className: styles.loaderContainer,
    "aria-label": "Loading experience...",
    style: {
      display: loader ? "block" : "none"
    }
  }, /*#__PURE__*/React.createElement(Bone, {
    style: {
      height: isMobile() ? mobileHeight : desktopHeight,
      width: isMobile() ? mobileWidth : desktopWidth
    }
  })), /*#__PURE__*/React.createElement(Picture, _extends({}, pictureProps, {
    id: image,
    pixelDensities: [1, 2],
    lazy: lazy,
    elementProps: {
      className: styles["picture-container"]
    },
    env: "production"
  }), /*#__PURE__*/React.createElement(Source, {
    viewport: "md",
    width: desktopWidth,
    height: desktopHeight,
    smartCrop: smartCrop
  }), /*#__PURE__*/React.createElement(Source, {
    viewport: "xs",
    width: mobileWidth,
    height: mobileHeight,
    smartCrop: smartCrop
  }), /*#__PURE__*/React.createElement(Img, {
    pixelDensity: 1,
    className: imageClassName,
    elementProps: elementProps,
    width: desktopWidth,
    height: desktopHeight,
    alt: alt,
    smartCrop: smartCrop,
    lazy: lazy
  })));
}
process.env.NODE_ENV !== "production" ? LazyloadImage.propTypes = {
  containerClassName: PropTypes.string,
  imageClassName: PropTypes.string,
  image: PropTypes.string,
  alt: PropTypes.string,
  ariaHidden: PropTypes.bool,
  desktopWidth: PropTypes.number,
  desktopHeight: PropTypes.number,
  mobileWidth: PropTypes.number,
  mobileHeight: PropTypes.number,
  smartCrop: PropTypes.bool,
  lazy: PropTypes.bool,
  show_spinner: PropTypes.bool,
  img_ratio: PropTypes.string,
  pictureProps: PropTypes.object
} : void 0;